import React from "react";
import { Link } from "../../layouts/menus/link";

type IHeaderButton = {
  title: string;
  url: string;
  icon?: any;
};

interface ICardHeader {
  title: string;
  subtitle?: string;
  button?: IHeaderButton;
}

export const CardHeader: React.FC<ICardHeader> = ({
  title,
  subtitle,
  button,
}) => {
  return (
    <div className="">
      <div className="flex flex-wrap items-center mb-2">
        <div>
          <span className="block text-500 font-medium ">
            {title.toUpperCase()}
          </span>
          {subtitle && <p className="text-xs text-gray-700">{subtitle}</p>}
        </div>
      </div>
    </div>
  );
};
